import {
  Command,
  Mark,
  markInputRule,
  markPasteRule,
  mergeAttributes,
} from "@tiptap/core";

export const Superscript = Mark.create({
  name: "superscript",

  defaultOptions: {
    HTMLAttributes: {},
  },

  parseHTML() {
    return [
      {
        tag: "superscript",
      },
      {
        tag: "del",
      },
      {
        tag: "superscript",
      },
      {
        style: "text-decoration",
        consuming: false,
        getAttrs: (style) => (style.includes("line-through") ? {} : false),
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "sup",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
      0,
    ];
  },

  addCommands() {
    return {
      setSuper:
        () =>
        ({ commands }) => {
          return commands.setMark("superscript");
        },
      toggleSuper:
        () =>
        ({ commands }) => {
          return commands.toggleMark("superscript");
        },
      unsetSuper:
        () =>
        ({ commands }) => {
          return commands.unsetMark("superscript");
        },
    };
  },
});
